import React, { PropsWithChildren } from 'react'
import { Dialog } from 'functional-foundations'
import { DialogType } from 'functional-foundations/types'
import Content, { LoaderContentPropsType } from './LoaderContent'

type PropsType = LoaderContentPropsType & DialogType

/**
 *
 */
const LoaderDialog = (props: PropsWithChildren<PropsType>): JSX.Element => {
    return <Dialog width={props.width || 600} {...props} title=''>
        <Content {...props}/>
    </Dialog>
}

export default LoaderDialog
